import React, { Component } from 'react';
import * as Constants from '../../../../common/Global/constants';
import {getLocalStorageVariables,
    isEmptyVariable, isEmptyArray,
    handleTokenExpiry} from '../../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {ExpandCollapseWrapper} from '../../../../common/Global/globalStyles.style';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-navigations/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";

let userDetails = getLocalStorageVariables();
const createdStatus="Created";
const updatedStatus="Updated";
const AddChildDropdownObj = {
    icon:"add_circle",
    label:"Add Child"
}
const AddSiblingDropdownObj = {
    icon:"add_box",
    label:"Add Sibling"
}
const editDropdownObj = {
    icon:"edit",
    label:"Edit"
}
const delDropdownObj = {
    icon:"delete",
    label:"Delete"
}

class FunctionTreeDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,

            functionMap:{},
            actionArr:[],
            syncFusionData:[],

            showCreateDialog:false,
            isEdit:false,
            createNodeType:"",
            selectedId:"",
            functionName:"",
            relativeFunctionId:"",
            clearAndResetFunctionTree:true,
            idToBeExpandedAfterAddingChild:"",

            operationType:"",
            deleteReactivateId:"",
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:"",
            showRadio:true,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
        }
        this.fields = {};
        this.functionObj = {};
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showFunctionsTreeDialog){
            this.fields = {
                dataSource:[],
                id:"functionId",
                text:"functionName",
                parentID:"parentId",
                child:"newChildren",
                expanded:"isExpanded"
            };

            this.setState({
                showLoader:false,
    
                functionMap:{},
                actionArr:[],
                syncFusionData:[],
    
                showCreateDialog:false,
                isEdit:false,
                createNodeType:"",
                selectedId:"",
                functionName:"",
                relativeFunctionId:"",
                clearAndResetFunctionTree:true,
                idToBeExpandedAfterAddingChild:"",

                operationType:"",
                deleteReactivateId:"",
                showAlertWithRadioDialog:false,
                alertWithRadioDialogMessage:"",

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
            },()=>{
                this.getFunctionTree();
            })
            
        }
    }

    handleAddEditDialogClose = (reloadFlag) =>{
        let id = "";
        if(this.state.createNodeType === "child") id = this.state.relativeFunctionId;
        this.setState({
            showCreateDialog:false,
            clearAndResetFunctionTree:false,
            isEdit:false,
            createNodeType:"",
            selectedId:"",
            functionName:"",
            relativeFunctionId:"",
            idToBeExpandedAfterAddingChild:id,
        },()=>{
            if(reloadFlag === true) this.getFunctionTree();
        })
    }

    onDropDownItemClick = (item,functionObj) => {
        if(item.label === "Add Child"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"child",
                relativeFunctionId:functionObj.functionId,
                
                isEdit:false,
            })
        }else if(item.label === "Add Sibling"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"sibling",
                relativeFunctionId:functionObj.functionId,
                
                isEdit:false,
            })
        }else if(item.label === "Delete"){
            let showRadio = true;
            if(isEmptyArray(this.state.functionMap[functionObj.functionId].children)){
                showRadio = false
            }

            this.setState({
                operationType:item.label,
                deleteReactivateId:functionObj.functionId,
                showAlertWithRadioDialog:true,
                showRadio:showRadio,
                alertWithRadioDialogMessage:"Are you sure you want to delete "+functionObj.functionName+"?"
            })
        }else if(item.label === "Edit"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"sibling",
                relativeFunctionId:functionObj.functionId,
                
                isEdit:true,
                selectedId:functionObj.functionId,
                functionName:functionObj.functionName,
            })
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleAlertWithDialogDialogClose = () =>{
        this.setState({
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:""
        });
    }

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            //this is backend level, it starts from 0, but front end level starts from 1
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    //No need of return value since the array itself is passed and updated.
    //Javascript maintains single array with pointers. it will not deep copy the array
    addParentIdandHasChildrenFlag = (tempArr, functionId, level) => {
        tempArr[functionId].level = level;

        if(!isEmptyArray(tempArr[functionId].children)){
            tempArr[functionId].children.map(childNode => {
                this.addParentIdandHasChildrenFlag(tempArr,childNode.functionId,level+1);
            });
        }else{
            tempArr[functionId].hasChildren = false;
        }
    }

    /************************API CALLS **************************/
    FunctionTree = (functionObj) => {

        return <div className="dialog-tree-structure-sync">
        {
            !isEmptyVariable(functionObj) &&
                <div className="tree-node-sync">
                        <div className="tree-text-layout">
                            <p className={functionObj.fontbold?"font-bold":""}>
                                {functionObj.functionName}
                            </p>
                            {
                                (functionObj.status === createdStatus ||
                                functionObj.status === updatedStatus) &&
                                <span className="new-tree-tag">New</span>
                            }
                        </div>
                    
                </div>
            }
        </div>
    }

    createSyncHRFusionData = (parentId,functionId,functionMap,isExpanded) => {
        //Now create an object
        let functionObj = functionMap[functionId];
        functionObj.newChildren = [];
        functionObj.isExpanded = isExpanded;
        if(parentId !== functionId){
            functionObj.parentId = parentId;
        }
        //now add children recursively
        functionObj.children.map((item)=>{
            functionObj.newChildren.push(this.createSyncHRFusionData(functionId,item.functionId,functionMap,false));
        });
        return functionObj;
    }

    updateSyncHRFusionData = (parentId,functionId,functionMap) => {
        //Now create an object
        let functionObj = functionMap[functionId];
        functionObj.newChildren = [];

        //Check the old function map
        if(!isEmptyVariable(this.state.functionMap[functionId])){
            functionObj.isExpanded = this.state.functionMap[functionId].isExpanded;
            functionMap[functionId].isExpanded = this.state.functionMap[functionId].isExpanded;
        }

        if(parentId !== functionId){
            functionObj.parentId = parentId;
        }
        //now add children recursively
        functionObj.children.map((item)=>{
            functionObj.newChildren.push(this.updateSyncHRFusionData(functionId,item.functionId,functionMap));
        });
        return functionObj;
    }

    getFunctionTree = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetFunctionsSubtree,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                rootFunctionId:this.props.rootFunctionId,
                departmentId:this.props.rootNode.departmentId,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.result.functionMap;
                let rootFunctionArr = this.getRootLevelFunctions(temp);

                rootFunctionArr.map((rootNode)=>{
                    this.addParentIdandHasChildrenFlag(temp,rootNode.functionId,1)
                })

                let syncFusionData = [];
                //clearAndResetFunctionTree - if it is false, then copy the isShowingChildren param 
                //from old state array, this is required because whenever the user adds a new node at the nth level
                //all the nodes are collapsed and shows only first level nodes since the API is called again
                if(!isEmptyArray(Object.keys(this.state.functionMap)) && 
                !this.state.clearAndResetFunctionTree){
                    let functionObj = this.updateSyncHRFusionData(this.props.rootFunctionId,this.props.rootFunctionId,temp);
                    functionObj.fontbold = true;
                    syncFusionData.push(functionObj);
                }else{
                    //create datastructure and Expand root level node's children by default
                    let functionObj = this.createSyncHRFusionData(this.props.rootFunctionId,this.props.rootFunctionId,temp,true);
                    temp[this.props.rootFunctionId].isExpanded = true;
                    functionObj.fontbold = true;
                    syncFusionData.push(functionObj);
                }

                //Action item arrays based on allowEdit flag
                let actionArrTemp = [];
                let actionArrRootTemp = [];
                if(this.props.rootNode.allowEdit === "Y"){
                    actionArrTemp = [AddChildDropdownObj,AddSiblingDropdownObj,editDropdownObj,delDropdownObj]
                    actionArrRootTemp = [AddChildDropdownObj,editDropdownObj]
                }

                //set the tree fields
                this.fields = {
                    dataSource:syncFusionData,
                    id:"functionId",
                    text:"functionName",
                    parentID:"parentId",
                    child:"newChildren",
                    expanded:"isExpanded"
                };

                this.setState({
                    functionMap:temp,
                    actionArr:actionArrTemp,
                    actionArrRoot:actionArrRootTemp,
                    idToBeExpandedAfterAddingChild:"",
                    syncFusionData:syncFusionData,
                    showLoader:false,
                    clearAndResetFunctionTree:false
                },()=>{
                    this.reference.refresh();
                });
            }else{
                this.setState({
                    functionMap:{},
                    showLoader:false,
                    syncFusionData:[],
                    clearAndResetFunctionTree:false
                });
            }
        });
    }

    moveTask = (draggedNodeId,draggedNodePid,droppedNodePid,droppedPos) => {
        fetch(Constants.Movefunction,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                rootFunctionId:this.props.rootFunctionId,
                functionId:draggedNodeId,
                fromFunctionId:draggedNodePid,
                toFunctionId:droppedNodePid,
                toChildOrder:droppedPos,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else {
                this.getFunctionTree();
            }
        });
    }

    expandAll = () => {
        this.reference.expandAll();
    }

    collapseAll = () => {
        this.reference.collapseAll();
    }

    dragStop = (args)=>{
        // console.log("Drag Node: "+JSON.stringify(args.draggedNodeData))
        // console.log("Drop Node: "+JSON.stringify(args.droppedNodeData))
        // console.log("Drop Level: "+args.dropLevel)

        //if the node is dropped above the parent node then cancel the drag
        if(args.dropLevel === 1){
            args.cancel = true;
        }
    }
    nodeExpanded = (args) =>{
        this.state.functionMap[args.nodeData.id].isExpanded = true;
    }
    nodeCollapsed = (args) =>{
        this.state.functionMap[args.nodeData.id].isExpanded = false;
    }
    nodeDrop = (args) => {

        let draggedNodeId = "";
        let draggedNodePid = "";

        let droppedNodeid = "";
        let droppedNodePid = "";
        let droppedPos = "";
        let dropLevel = "";

        if(!isEmptyVariable(args.draggedNodeData) && !isEmptyVariable(args.droppedNodeData)){
            draggedNodeId = args.draggedNodeData.id;
            draggedNodePid = args.draggedNodeData.parentID;

            droppedNodeid = args.droppedNodeData.id;
            droppedNodePid = args.droppedNodeData.parentID;
            droppedPos = args.dropIndex + 1;
            dropLevel = args.dropLevel;

            // now check what is the level of drop id
            let dropRelativeNodeLevel = this.state.functionMap[droppedNodeid].level;
            //dropped level is greater than relative node, then it is a child of that relative node
            //hence parent id is relative node id
            if(dropLevel > dropRelativeNodeLevel){
                droppedNodePid = droppedNodeid;
            }

            this.moveTask(draggedNodeId,draggedNodePid,droppedNodePid,droppedPos);
        }
    }

    render() {
        return(
            <div>
                <Modal className="show-functions-tree-dialog custom-dialog" 
                show={this.props.showFunctionsTreeDialog} 
                onHide={this.props.handleFunctionTreeDialogClose}>
                    <Modal.Header>
                        <h5>Function Tree</h5>
                        <button 
                            onClick={this.props.handleFunctionTreeDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <ExpandCollapseWrapper themeSettings={this.props.themeSettings}>
                            <div className="expand-collapse-layout"
                                onClick={this.expandAll}
                                style={{marginRight:10}}
                                type="button">
                                <span class="material-icons">unfold_more</span>
                                <p>Expand All</p>
                            </div>
                            <div
                                className="expand-collapse-layout"
                                onClick={this.collapseAll}
                                style={{marginLeft:10}}
                                type="button">
                                <span class="material-icons">unfold_less</span>
                                <p>Collapse All</p>
                            </div>

                        </ExpandCollapseWrapper>
                        <TreeViewComponent 
                            fields={this.fields} 
                            allowDragAndDrop={false}
                            nodeTemplate={this.FunctionTree}
                            ref = {(treeNode) => {this.reference = treeNode}}
                            nodeDragStop={this.dragStop}
                            nodeDropped = {this.nodeDrop}
                            nodeExpanded = {this.nodeExpanded}
                            nodeCollapsed = {this.nodeCollapsed}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default FunctionTreeDialog;